import React from "react";
import { Button } from "primereact/button";
import { useAppSelector } from "../../hooks/storeHooks";
import { selectAiSummariesUpdateLoadingForSection } from "../../store/selectors/aiSummarySelectors";

interface SectionSaveButtonProps {
    sectionKey: string;
    hasBeenEdited: boolean;
    editableText: string;
    onSave: () => void;
}

export const SectionSaveButton: React.FC<SectionSaveButtonProps> = ({ 
    sectionKey, 
    hasBeenEdited, 
    editableText, 
    onSave 
}) => {
    const isSectionLoading = useAppSelector(selectAiSummariesUpdateLoadingForSection(sectionKey));

    return (
        <Button
            label="Save"
            icon="pi pi-save"
            className={`p-button-sm ${hasBeenEdited ? 'p-button-success' : 'p-button-secondary'}`}
            loading={isSectionLoading}
            onClick={onSave}
        />
    );
};